import { createReducer } from '@reduxjs/toolkit';
import { getHomePage } from '../actions/homePage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getHomePage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
